/**
 * yd-quote-fill: 文字随滚动逐字「填色」。char 级。无外部库。
 * 源自 web-hand-off quote-fill.js：删 partials:loaded，补 shopify:section:load。
 * [data-quote-fill] 单段；[data-fill-group]/[data-fill-word] 词组；[data-vision-pin] 钉住驱动。
 * 颜色由 CSS 按上下文定义。尊重 reduced-motion。幂等。
 */
(function () {
  var clamp01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  function buildChars(el) {
    if (el.dataset.fillBuilt) return [].slice.call(el.querySelectorAll('.fill-ch'));
    el.dataset.fillBuilt = '1';
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var chars = [];
    words.forEach(function (w, wi) {
      var ws = document.createElement('span'); ws.className = 'fill-word';
      for (var i = 0; i < w.length; i++) {
        var c = document.createElement('span'); c.className = 'fill-ch'; c.textContent = w[i];
        ws.appendChild(c); chars.push(c);
      }
      el.appendChild(ws);
      if (wi < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    return chars;
  }
  function bind(driver, chars, pinEl) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (pinEl) pinEl.classList.add('is-static');
      chars.forEach(function (c) { c.classList.add('is-on'); });
      return;
    }
    var ticking = false;
    var onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var vh = window.innerHeight, p;
        if (pinEl) {
          var pr = pinEl.getBoundingClientRect();
          var total = pr.height - vh;
          p = clamp01((total > 0 ? -pr.top / total : 0) / 0.78);
        } else {
          var r = driver.getBoundingClientRect();
          p = clamp01((vh * 0.78 - r.top) / (vh * 0.5));
        }
        var n = Math.round(p * chars.length);
        for (var i = 0; i < chars.length; i++) chars[i].classList.toggle('is-on', i < n);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
  function init() {
    document.querySelectorAll('[data-quote-fill]').forEach(function (el) {
      if (el.dataset.fillReady) return; el.dataset.fillReady = '1';
      bind(el, buildChars(el));
    });
    document.querySelectorAll('[data-fill-group]').forEach(function (g) {
      if (g.dataset.fillReady) return; g.dataset.fillReady = '1';
      var chars = [];
      g.querySelectorAll('[data-fill-word]').forEach(function (el) { chars = chars.concat(buildChars(el)); });
      bind(g, chars, g.closest('[data-vision-pin]'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
